/* eslint-disable */
import moment from 'moment';
import _get from 'lodash/get';

const avalibleLang = ['ru', 'uk', 'en', 'ua', 'cz', 'cs', 'pl', 'pt'];
const avalibleCountry = {
  uk: '+38',
  ru: '+7',
  pl: '+48',
  de: '+49',
  cz: '+420',
  cs: '+420',
  pt: '+55',
  nl: '+31',
  be: '+32',
  fr: '+33',
  at: '+43',
  es: '+34',
  pr: '+351',
  ch: '+41',
  gr: '+30',
  al: '+355',
  mt: '+356',
  cy: '+357',
  am: '+374',
  rs: '+381',
  me: '+382',
  hr: '+385',
  si: '+386',
  ba: '+387',
  mk: '+389',
  it: '+39',
  bg: '+359',
  hu: '+36',
  md: '+373',
  by: '+375',
  ro: '+40',
  sk: '+421',
  lt: '+370',
  lv: '+371',
  ee: '+372',
  gb: '+44',
  dk: '+45',
  se: '+46',
  no: '+47',
  ie: '+353',
  is: '+354',
  fi: '+358',
  tr: '+90',
};

export function b64EncodeUnicode(str) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1);
  }));
}

export function b64DecodeUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(str).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

export function getLang() {
  const route = location.pathname.split('/');
  route.shift();

  return avalibleLang.includes(route[0]) ? route[0] : document.getElementById('app').dataset.lang;
}

export function getLocale() {
  let urlLang = getLang();
  urlLang = urlLang === 'ua' ? 'uk' : urlLang;
  if (urlLang === 'cz') urlLang = 'cs';

  const selected = localStorage.getItem('__octobus-locale');
  const curr = urlLang || selected || 'ru';

  if (selected !== curr) localStorage.setItem('__octobus-locale', curr);

  return curr;
}

export function getComponentLocale(srcLang) {
  let componentLocale = srcLang;
  if (componentLocale === 'pt') { componentLocale = 'pt-br'; }
  if (componentLocale === 'cz') { componentLocale = 'cs'; }
  if (componentLocale === 'ua') { componentLocale = 'uk'; }
  return componentLocale;
}

/*
+31	99 9999 999	код Нидерландов
+32	99 999 99 99	код Бельгии
+33	9 99 99 99 99	код Франции
+43	999 999 9999	код Австрии
+34	999 999 999	код Испании
+351	99 9999 999	код Португалии
+41	99 999 9999	код Швейцарии +41 (31) 520-70-40
+30	99 999 99999	код Греции +30 (21) 123-401-00
+355	999 9999 999	код Албании
+356	99 999 999	код Мальты +356 (20) 341-599
+357	99 999 999	код Кипра (Республика Кипр) +357 (22) 030-600
+381	99 999 9999	код Сербии
+382	99 999 999	код Черногории
+385	9 999 9999	код Хорватии +385 (1) 800-03-34
+386	9 999 9999	код Словении +386 (1) 777-43-99
+387	99 999 999	код Боснии и Герцеговины
+389	99 999 999	код Македонии (Северной Македонии)
+39	99 999 999 99	код Италии +39 (06) 976-302-00
+36	9 999 9999	код Венгрии +36 (1) 445-38-99
+359	9 999 9999	код Болгарии +359 (2) 492-88-00
+373	999 99 999	код Молдовы
+40	99 999 9999	код Румынии +40 (31) 229-52-22
+420	(999) 999-999	код Чехии +420 (2) 342-618-88
+421	(999) 999-999	код Словакии +421 (2) 335-276-76
+48	(99) 999-99-99	код Польши
+370	9999 9999	код Литвы +370 (5) 208-09-99
+371	99 999 999	код Латвии +371 (67) 881-818
+372	999 9999	код Эстонии +372 (63) 462-61
+44	99 999 999 99	код Великобритании +44 7911 123 456, +44 (20) 380-705-99
+45	9999 9999	код Дании +45 (78) 76-84-44
+46	999 9999 999	код Швеции +46 (8) 420-029-99
+47	9999 9999	код Норвегии +47 (2) 1966-100
+353	999 9999 999	код Ирландии +353 (1) 960-98-88
+354	999 9999	код Исландии
+358	9 9999 9999	код Финляндии +358 (9) 4270-4800
+37 999 99999999 старый код ГДР. discontinued
+49 999 99999999 код Германии
+90 999 9999999 код Турции
*/

export function getMask(phone, defaultMask = '(999) 999-99-99') {
  const { uk, pl, cz, cs, ru, de, pt, me, be, fr, at, es, nl, pr, ch, gr, al, mt, cy, am, rs, hr, si, ba, mk, it, hu, bg, md, ro, sk, lt, lv, ee, gb, dk, se, no, ie, fi, is, tr } = avalibleCountry;
  let mask = '';

  switch (phone) {
    case uk:
      mask = '(999) 999-99-99';
      break;
    case pl:
      mask = '(99) 999-99-99';
      break;
    case cz:
      mask = '(999) 999-999';
      break;
    case cs:
      mask = '(999) 999-999';
      break;
    case ru:
      mask = '(999) 999-99-99';
      break;
    case de:
      mask = '999 99999999';
      break;
    case pt:
      mask = '(999) 999-99-99';
      break;
    case me:
      mask = '99 999 999';
      break;
    case be:
      mask = '99 999 99 99';
      break;
    case fr:
      mask = '9 99 99 99 99';
      break;
    case at:
      mask = '999 999 9999';
      break;
    case es:
      mask = '999 999 999';
      break;
    case nl:
      mask = '99 9999 999';
      break;
    case pr:
      mask = '99 9999 999';
      break;
    case ch:
      mask = '99 999 9999';
      break;
    case gr:
      mask = '99 999 99999';
      break;
    case al:
      mask = '999 9999 999';
      break;
    case mt:
      mask = '99 999 999';
      break;
    case cy:
      mask = '99 999 999';
      break;
    case am:
      mask = '999 999';
      break;
    case rs:
      mask = '99 999 9999';
      break;
    case hr:
      mask = '9 999 9999';
      break;
    case si:
      mask = '9 999 9999';
      break;
    case ba:
      mask = '99 999 999';
      break;
    case mk:
      mask = '99 999 999';
      break;
    case it:
      mask = '99 999 999 99';
      break;
    case hu:
      mask = '9 999 9999';
      break;
    case bg:
      mask = '9 999 9999';
      break;
    case md:
      mask = '999 99 999';
      break;
    case ro:
      mask = '99 999 9999';
      break;
    case sk:
      mask = '(999) 999-999';
      break;
    case lt:
      mask = '9999 9999';
      break;
    case lv:
      mask = '99 999 999';
      break;
    case ee:
      mask = '999 9999';
      break;
    case gb:
      mask = '99 999 999 99';
      break;
    case dk:
      mask = '9999 9999';
      break;
    case se:
      mask = '999 9999 999';
      break;
    case no:
      mask = '9999 9999';
      break;
    case ie:
      mask = '999 9999 999';
      break;
    case fi:
      mask = '999 9999 999';
      break;
    case is:
      mask = '999 9999';
      break;
    case tr:
      mask = '(999) 999-9999';
      break;
    default:
      mask = defaultMask;
  }

  return mask;
}

export function getCountryCode(phone) {
  const country = Object.keys(avalibleCountry).find((country) => {
    const prefix = avalibleCountry[country];

    return phone.includes(prefix);
  });

  return {
    country: avalibleCountry[country],
    phone: phone.replace(avalibleCountry[country], ''),
  }
}

export const isUrlLang = (() => {
  return document.getElementById('app').dataset.urlLang === '1';
})();

export const useDefaultPoints = (() => {
  return document.getElementById('app').dataset.defaultPoints === '1';
})();

export const getBaseDate = element => element ? element.dataset : {};
export const getBaseCurrency = () => typeof localStorage === 'object' ? localStorage.getItem('__octobus__search-currency') : 'UAH';

export function getTomorrow() {
  return new Date(moment(new Date()).add(1,'days'));
}

export function getCustomRoutes() {
  let routes = null;

  try {
    const { customRoutes = '{}' } = document.getElementById('app').dataset;

    routes = JSON.parse(customRoutes);
  } catch (error) {
    routes = {};
  }

  return {
    main: routes.main || '/',
    search: routes.search || 'search',
    checkout: routes.checkout || 'checkout',
    success: routes.success || 'buy/success',
    error: routes.error || 'buy/error',
    results: routes.results || 'buses/*',
    profile: routes.results || 'profile',
    tickets: routes.tickets || 'tickets',
  };
}

export function getFileName(response) {
  const header = response.headers['content-disposition'] || '';
  const fileName = header.match(/filename="(.+)"/)[1];
  return fileName || 'ticket.pdf';
}

export function errorFromBlob(blob) {
  return blob.text().then((text) => {
    if (blob.type !== 'application/json') return null;
    try {
      const { error } = JSON.parse(text);
      return (error ? error.name : null) || null;
    } catch (e) {
      return null;
    }
  });
}

export function getOrderData() {
  try {
    return JSON.parse(localStorage.getItem('__octobus__buy-tickets'));
  } catch (e) {
    return null;
  }
}

export function setOrderData(order) {
  localStorage.setItem('__octobus__buy-tickets', JSON.stringify(order));
}

export function clearOrderFlowData() {
  ['__octobus__buy-tickets', '__octobus__search-cnt']
    .forEach(key => localStorage.removeItem(key));
}

export function getBuyer() {
  const buyerDataBase64 = localStorage.getItem('__octobus-user');
  if (buyerDataBase64) {
    try {
      return JSON.parse(b64DecodeUnicode(buyerDataBase64));
    } catch (e) {
      localStorage.removeItem('__octobus-user');
    }
  }
  return null;
}

export function getBuyerId() {
  const buyer = getBuyer();
  return buyer && buyer.id;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js